<div class="dialog modal-md">
    <div class="dialog-title">
        <h4>Add Comment<img src="assets/svg/close-white.svg" alt="close" (click)="close()" ></h4>
    </div>
    <div class="d-flex flex-column clsbidtable mt-3">
        <div class="moving-cart-items">
            <div class="cart-heading mb-2">
                <div class="col-md-2"> 
                    <p>S.no</p>
                </div> 
                <div class="col-md-10"> 
                    <p>Comments</p>
                </div>  
            </div>
              <div class="cart-data d-flex pointer"  *ngFor="let item of commentsList; let i = index" > 
                <div class="text-data col-md-2">
                    <p class=" no-margin-top">
                       {{i+1}}
                    </p>
                </div>
                <div class="text-data col-md-10">
                        <p class=" no-margin-top">
                           {{item.comments}}
                        </p>
                    </div>
              </div>
              <!-- <div class="pagination-list ">
                <div class="pointer ">
                    <img class="previous" src="assets/svg/Left box.svg" 
                    [ngClass]="activeFirstPage? 'emptyData' : 'data'" (click)="previouspage()">
                </div>
                <div class="number pointer ">
                    <h6>{{activePage}}</h6>
                </div>
                <div class="pointer ">
                    <img class="next" src="assets/svg/Right Box.svg" 
                    [ngClass]="noData? 'emptyData':'data'" (click)="nextPage()">
                </div>
            </div>
            <div class="text">Showing {{ticketList.length}} tickets of {{activeTotal}} Total tickets</div> -->
            </div>
        </div>

        <div class="custom-form">
            <label>Comment</label>  
            <textarea rows="4" cols="68" [(ngModel)]="comments"  placeholder="Enter Comment"></textarea>
            <!-- <span class="form-error-text" style="float: left;" *ngIf="isSubmitted && createTicketForm.controls.message.invalid">Message Required</span> -->
        </div>
        <button class="bor-orange" (click)="postComment()">Post</button>
  
</div>

<div *ngIf="showLoader" class="loader">
    <img src="assets/svg/preloader.svg" alt="">
</div>